import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

const IconsContainer = ({ iconos = [] }) => {
  if (!iconos.length) {
    return null; // No renderizar si no hay iconos
  }

  return (
    <Box
      sx={{
        width: "100%",
        boxSizing: "border-box",
        px: { xs: 1, sm: 2, md: 3 },
        boxShadow: "0px -8px 24px -8px rgba(0,0,0,0.12)",
        py: { xs: 2, sm: 3, md: 4 },
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(2, 1fr)", // 2 columnas en mobile
          sm: "repeat(2, 1fr)", // 2 columnas en tablet
          md: "repeat(auto-fit, minmax(150px, 1fr))", // auto en desktop
        },
        gap: {
          xs: "16px",
          sm: "24px",
          md: "32px",
        },
        alignItems: "center",
        justifyItems: "center",
      }}
    >
      {iconos.map((icono, index) => (
        <a
          key={index}
          href={icono.link || "#"}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textDecoration: "none",
            width: "100%",
            height: "100%",
          }}
        >
          <img
            src={icono.icono}
            alt={icono.titulo}
            style={{
              width: "100%",
              maxWidth: "180px",
              minWidth: "120px",
              height: "auto",
              transition: "transform 0.2s",
              cursor: "pointer",
              objectFit: "contain",
              display: "block",
            }}
            onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          />
        </a>
      ))}
    </Box>
  );
};

IconsContainer.propTypes = {
  iconos: PropTypes.arrayOf(
    PropTypes.shape({
      icono: PropTypes.string.isRequired,
      titulo: PropTypes.string.isRequired,
      link: PropTypes.string,
    })
  ),
};

export default IconsContainer;